import { useLocation } from "react-router-dom";
import HelpButton from "@/components/HelpButton";

// The home page and the workspace have their own header with the "?" in it. Every other page
// (sign-in, pricing, settings, legal, invites, /help itself) gets the same "?" pinned top-right.
const OWN_HEADER = ["/", "/workspace"];
const ROUTES = ["/login", "/pricing", "/settings", "/verify-email", "/invite", "/admin", "/help", "/support",
  "/privacy", "/terms", "/cookies", "/refund", "/payment"];

export default function PublicHelpButton() {
  const { pathname } = useLocation();
  if (OWN_HEADER.includes(pathname)) return null;
  if (!ROUTES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return null;
  return (
    // Bottom-right, not top-right: pinned at the top it sat over page headers and nav on phone widths.
    // z-30 keeps it under sticky headers, phone menus, drawers and dialogs, which all sit higher.
    <div className="fixed bottom-4 right-4 z-30" style={{ bottom: "max(1rem, env(safe-area-inset-bottom))" }}
      data-testid="public-help-header">
      <HelpButton />
    </div>
  );
}
